import * as React from "react";
import type { SVGProps } from "react";

const GridFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_3187_54540)">
      <path
        d="M10.9209 0H3.30133C1.47806 0 0 1.47806 0 3.30133V10.9209C0 12.7442 1.47806 14.2222 3.30133 14.2222H10.9209C12.7442 14.2222 14.2222 12.7442 14.2222 10.9209V3.30133C14.2222 1.47806 12.7442 0 10.9209 0Z"
        fill="currentColor"
      />
      <path
        d="M28.6987 0H21.0791C19.2558 0 17.7778 1.47806 17.7778 3.30133V10.9209C17.7778 12.7442 19.2558 14.2222 21.0791 14.2222H28.6987C30.5219 14.2222 32 12.7442 32 10.9209V3.30133C32 1.47806 30.5219 0 28.6987 0Z"
        fill="currentColor"
      />
      <path
        d="M10.9209 17.7778H3.30133C1.47806 17.7778 0 19.2558 0 21.0791V28.6987C0 30.5219 1.47806 32 3.30133 32H10.9209C12.7442 32 14.2222 30.5219 14.2222 28.6987V21.0791C14.2222 19.2558 12.7442 17.7778 10.9209 17.7778Z"
        fill="currentColor"
      />
      <path
        d="M28.6987 17.7778H21.0791C19.2558 17.7778 17.7778 19.2558 17.7778 21.0791V28.6987C17.7778 30.5219 19.2558 32 21.0791 32H28.6987C30.5219 32 32 30.5219 32 28.6987V21.0791C32 19.2558 30.5219 17.7778 28.6987 17.7778Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3187_54540">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GridFilledIcon;

